import React from 'react';
import {
  AddNoteIcon,
  AddPersonIcon,
  GiftIcon,
  LogoutIcon,
  MagnifyingGlassIcon,
  ReminderAlarmClockIcon,
  SpeechBubbleIcon,
} from '@repo/icons';
import { openModal, startNewContact, startNewNote, startNewReminder } from '@repo/redux/actions/ui';
import { Dispatch } from 'redux';
import { UserAction, UserSession } from '@repo/utils/types';
import { copyReferralToClipboard, trackReferral } from '@components/utils/referral-sharing';
import { NavigateFunction } from 'react-router-dom';
import { NexusFlowerIcon } from '@repo/icons/AIFlower';
import { clearNewConversation } from '@repo/redux/actions/nexus';

const buildUniversalActions = (
  dispatch: Dispatch,
  navigate: NavigateFunction,
  user: UserSession,
  authLogoutFunction: () => void,
  contactLimitExceeded: boolean,
): Array<UserAction> =>
  [
    {
      title: 'Add Note',
      type: 'action',
      action: () => dispatch(startNewNote),
      icon: AddNoteIcon,
      keyboard: 'n',
    },
    {
      title: 'Set Reminder',
      type: 'action',
      action: () => dispatch(startNewReminder),
      icon: ReminderAlarmClockIcon,
      keyboard: 'r',
    },
    !contactLimitExceeded && {
      title: 'Add a Person',
      type: 'action',
      action: () => dispatch(startNewContact()),
      icon: AddPersonIcon,
      keyboard: 'p',
    },
    {
      title: 'Ask Nexus',
      type: 'action',
      action: () => {
        dispatch(clearNewConversation);
        navigate('/nexus');
      },
      icon: (props) => <NexusFlowerIcon strokeWidth={1.8} {...props} />,
      synonyms: ['ai', 'chat', 'nexus'],
    },
    {
      title: 'Search',
      type: 'action',
      action: () => {
        navigate('/search');
      },
      icon: MagnifyingGlassIcon,
      keyboard: '/',
    },
    {
      title: 'Invite a friend to Clay',
      type: 'action',
      action: () => {
        copyReferralToClipboard(user, dispatch);
        trackReferral();
      },
      icon: GiftIcon,
      synonyms: ['referral'],
    },
    {
      title: 'Support',
      type: 'action',
      action: () => dispatch(openModal('support')),
      icon: SpeechBubbleIcon,
      synonyms: ['help'],
    },
    {
      title: 'Sign out',
      type: 'action',
      action: () => authLogoutFunction(),
      icon: LogoutIcon,
      synonyms: ['logout'],
    },
  ].filter((action) => !!action);

export default buildUniversalActions;
